export default __webpack_public_path__ + "static/media/favicon.96b27339.png";